import React, { useState, useRef } from "react";
import "./AccordionList.css";

import SlButton from '@shoelace-style/shoelace/dist/react/button';

import { RxCaretRight } from "react-icons/rx";
import { MdDownload } from "react-icons/md"

import { sPullFile } from "../../utils/sPullFile";


export const formatDate = (date) => date.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");

export const formatAddress = (indirizzo, comune, provincia) => {
    const addressParts = [
        indirizzo,
        comune,
        provincia ? `(${provincia})` : ''
    ].filter(Boolean); // Filter out any empty values
    return addressParts.join(', ');
}

const formatKeyName = (str) => {
    return str
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
}

const formatNumberSep = (str) => {
    const number = parseFloat(str) / 100;
    return number.toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
    });
};


const customCleanEmpty = (obj) => {
    // Check if obj is a non-empty object and iterate over its keys
    if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
            if (obj[key] && typeof obj[key] === 'object') {
                // Recursively clean nested objects
                customCleanEmpty(obj[key]);
                // If the nested object is empty, delete the key
                if (Object.keys(obj[key]).length === 0) {
                    delete obj[key];
                }
            } else if (
                obj[key] === null ||  // Remove if null
                (Array.isArray(obj[key]) && obj[key].length === 0) ||  // Remove if empty array
                (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) // Remove if empty object
            ) {
                delete obj[key];
            }
        }
    }
    return obj;
}


const AccordionBlock = ({ element, isOpen, toggleOpen }) => {

    const handleDownload = (e) => {
        e.stopPropagation();
        sPullFile(element.s3Key);
    }


    const hiddenRef = useRef(null); // To access the height of the hidden content
    
    // remove the empty sections from the json
    let cleanExtraction = JSON.parse(JSON.stringify(element.extractionResult));
    cleanExtraction = customCleanEmpty(cleanExtraction);
    
    const infoContribuente = cleanExtraction.contribuente;
    const indirizzoContribuente = formatAddress(
        infoContribuente.indirizzo_domicilio,
        infoContribuente.comune_domicilio,
        infoContribuente.provincia_domicilio
    );

    return (
        <div className="accordion-block">
            <div className="header" onClick={toggleOpen}>
                <span className={`caret ${isOpen ? "rotate90" : ""}`} >
                    <RxCaretRight />
                </span>
                <div className="field-column">
                    <span className="field-name">Contribuente</span>
                    <span className="field-value">{element.cfContribuente}</span>
                </div>
                <div className="field-column">
                    <span className="field-name">Data pagamento</span>
                    <span className="field-value">{formatDate(element.paymentDate)}</span>
                </div>

                <SlButton className="btn-download" size="small" onClick={(e) => {handleDownload(e)}} >
                    <MdDownload />
                </SlButton>

            </div>

            <div
                ref={hiddenRef}
                className="hidden"
                style={{ maxHeight: isOpen ? `${hiddenRef.current.scrollHeight}px` : "0px" }}
            >
                <div className="divider" />

                <div className="content">
                    
                    <span className="title-section">Dati contribuente</span>
                    <ul>
                        {infoContribuente.codice_fiscale && (
                            <li>Codice Fiscale: <strong>{infoContribuente.codice_fiscale}</strong></li>
                        )}
                        {infoContribuente.denominazione && (
                            <li>Denominazione: <strong>{infoContribuente.denominazione}</strong></li>
                        )}
                        {indirizzoContribuente && (
                            <li>Indirizzo: <strong>{indirizzoContribuente}</strong></li>
                        )}
                    </ul>

                    {cleanExtraction.payments_pages.map((page, index) => (
                        <>
                            <div className="page-divider">{`Pagina ${index+1}`}</div>
                            
                            {page.erario && (
                                <>
                                <span className="title-section">Sezione Erario</span>
                                {(page.erario.codice_ufficio || page.erario.codice_atto) && (
                                    <ul>
                                        {page.erario.codice_ufficio && (
                                            <li>Codice Ufficio: <strong>{page.erario.codice_ufficio}</strong></li>
                                        )}
                                        {page.erario.codice_atto && (
                                            <li>Codice Atto: <strong>{page.erario.codice_atto}</strong></li>
                                        )}
                                    </ul>
                                )}
                                {page.erario.righe.map((riga, rigaIndex) => (
                                    <div className="row-block">
                                        <span className="row-block-title" >Riga</span>
                                        <div className="row-block-divider" />
                                        <ul key={rigaIndex} >
                                            {Object.entries(riga).map(([key, value]) => (
                                                <li key={key}>
                                                    {formatKeyName(key)}: <strong>{key.startsWith("importo_") ? formatNumberSep(value) : value}</strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                                </>
                            )}

                            {page.inps && (
                                <>
                                <span className="title-section">Sezione INPS</span>
                                {page.inps.righe.map((riga, rigaIndex) => (
                                    <div className="row-block">
                                        <span className="row-block-title" >Riga</span>
                                        <div className="row-block-divider" />
                                        <ul key={rigaIndex} >
                                            {Object.entries(riga).map(([key, value]) => (
                                                <li key={key}>
                                                    {formatKeyName(key)}: <strong>{key.startsWith("importo_") ? formatNumberSep(value) : value}</strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                                </>
                            )}

                            {page.regioni && (
                                <>
                                <span className="title-section">Sezione Regioni</span>
                                {page.regioni.righe.map((riga, rigaIndex) => (
                                    <div className="row-block">
                                        <span className="row-block-title" >Riga</span>
                                        <div className="row-block-divider" />
                                        <ul key={rigaIndex} >
                                            {Object.entries(riga).map(([key, value]) => (
                                                <li key={key}>
                                                    {formatKeyName(key)}: <strong>{key.startsWith("importo_") ? formatNumberSep(value) : value}</strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                                </>
                            )}

                            {page.imu && (
                                <>
                                <span className="title-section">Sezione IMU</span>
                                {page.imu.identificativo_operazione && (
                                    <ul>
                                        <li>Identificativo Operazione: <strong>{page.imu.identificativo_operazione}</strong></li>
                                    </ul>
                                )}
                                {page.imu.righe.map((riga, rigaIndex) => (
                                    <div className="row-block">
                                        <span className="row-block-title" >Riga</span>
                                        <div className="row-block-divider" />
                                        <ul key={rigaIndex} >
                                            {Object.entries(riga).map(([key, value]) => (
                                                <li key={key}>
                                                    {formatKeyName(key)}: <strong>{key.startsWith("importo_") ? formatNumberSep(value) : value}</strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                                </>
                            )}

                            {page.inail && (
                                <>
                                <span className="title-section">Sezione INAIL</span>
                                {page.inail.righe.map((riga, rigaIndex) => (
                                    <div className="row-block">
                                        <span className="row-block-title" >Riga</span>
                                        <div className="row-block-divider" />
                                        <ul key={rigaIndex} >
                                            {Object.entries(riga).map(([key, value]) => (
                                                <li key={key}>
                                                    {formatKeyName(key)}: <strong>{key.startsWith("importo_") ? formatNumberSep(value) : value}</strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                                </>
                            )}
                            
                            {page.altri_enti && (
                                <>
                                <span className="title-section">Sezione Altri Enti</span>
                                {page.altri_enti.codice_ente && (
                                    <ul>
                                        <li>Codice Ente: <strong>{page.altri_enti.codice_ente}</strong></li>
                                    </ul>
                                )}
                                {page.altri_enti.righe.map((riga, rigaIndex) => (
                                    <div className="row-block">
                                        <span className="row-block-title" >Riga</span>
                                        <div className="row-block-divider" />
                                        <ul key={rigaIndex} >
                                            {Object.entries(riga).map(([key, value]) => (
                                                <li key={key}>
                                                    {formatKeyName(key)}: <strong>{key.startsWith("importo_") ? formatNumberSep(value) : value}</strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                                </>
                            )}
                        
                        </>
                    ))}

                </div>
            </div>

        </div>
    );
};


const AccordionList = ({ data }) => {
    
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="accordion-list">
        {data.map((el, index) => (
            <AccordionBlock
                key={index}
                element={el}
                isOpen={openIndex === index}
                toggleOpen={() => handleToggle(index)}
            />
        ))}
        </div>
    );
};

export default AccordionList;
